import { IWireDisbursementFormData } from 'types/order/escrow/wires/IWireDisbursementFormData';
import React from 'react';
import { IBaseDisbursementStatusPill } from '../IBaseDisbursementStatusPill';
import { assertValueIsOfType } from 'utilities/Assertions';
import { BaseStatusPill } from '../shared/BaseStatusPill';
import { DateFormat, getDateString } from '../../../../../../ui-toolkit/utilities/getDateString';

export const getWirePillDetails = (wire: IWireDisbursementFormData) => {
  switch (true) {
    case !!wire.voidedAt:
      return 'Void';
    case !!wire.sendAt:
      return 'Disbursed';
    case !!wire.enqueuedForDisbursementAt:
      return 'Initiated';
    case !!wire.holdback:
      return 'Holdback';
    default:
      return 'Staged';
  }
};

export const WireStatusPill: React.FC<IBaseDisbursementStatusPill> = ({ disbursement, amountMismatch }) => {
  assertValueIsOfType<IWireDisbursementFormData>(
    disbursement,
    () => disbursement.type === 'Wire',
    `I was supposed to only be passed a wire and I was passed a ${disbursement.type} instead`
  );

  const status = getWirePillDetails(disbursement);
  const dateForTooltip =
    disbursement.holdbackProperties?.dueDate ?? disbursement.sendAt ?? disbursement.enqueuedForDisbursementAt;
  const dateDisplay = dateForTooltip ? getDateString(DateFormat.short, dateForTooltip) : undefined;
  return (
    <BaseStatusPill
      status={status}
      text={'Wire'}
      amountCents={disbursement.amountCents}
      id={disbursement.id}
      title={dateDisplay}
      hasWarning={amountMismatch}
    />
  );
};
